import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const accountCompanyNameFieldStyles = StyleSheet.create({
	readRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	editRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	// Sits on the name's baseline rather than the row's, so the pencil does not enlarge the header.
	editButton: {
		flex: 'none',
		height: 24,
		width: 24,
	},
	saveLink: {
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.xs,
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		':hover': { color: THEME.colors.hover.main },
	},
	cancelButton: {
		height: 24,
		width: 24,
	},
});
